import { ParentProps } from 'solid-js';
import { StyledBox } from './box.styled';

export const Box = (props: ParentProps) => <StyledBox>{props.children}</StyledBox>;
